import firehydrantAPI from 'helpers/firehydrantAPI';
import { createMutationHook, useApiQuery } from 'queries/common';

const createFunctionality = (body) =>
  firehydrantAPI.post('functionalities', body);

export const useCreateFunctionality = createMutationHook(createFunctionality);

const updateFunctionality = (body) =>
  firehydrantAPI.patch(`functionalities/${body.id}`, body);

export const useUpdateFunctionality = createMutationHook(updateFunctionality);

const deleteFunctionality = (id) =>
  firehydrantAPI.delete(`functionalities/${id}`);

export const useDeleteFunctionality = createMutationHook(deleteFunctionality);

export const useFunctionalities = (params, options = {}) => {
  const requestParams = { params: { per_page: 20, lite: true, ...params } };

  const query = useApiQuery(
    ['functionalities', 'list', requestParams.params],
    () => firehydrantAPI.get('functionalities', requestParams),
    options,
  );

  return {
    ...query,
    pagination: query.data?.data?.pagination,
    functionalities: query.data?.data?.data,
  };
};

export const useMetricsFunctionalities = (id, startDate, endDate) => {
  const query = useApiQuery(
    ['metrics/functionalities', 'list', { id, startDate, endDate }],
    () =>
      firehydrantAPI.get(
        `/metrics/functionalities/${id}?start_date=${startDate}&end_date=${endDate}`,
      ),
  );

  return {
    ...query,
    data: query.data?.data,
  };
};

export const useFunctionality = (id) => {
  const query = useApiQuery(
    ['functionalities', 'detail', id || 'none'],
    () => firehydrantAPI.get(`functionalities/${id}`),
    { enabled: !!id },
  );

  return {
    isLoading: query.isLoading,
    errors: query.error,
    functionality: query.data?.data,
  };
};

export const useFunctionalityShow = (id) => {
  const functionalityQuery = useApiQuery(
    ['functionalities', 'detail', id || 'none'],
    () => firehydrantAPI.get(`/functionalities/${id}`),
  );

  const activeIncidentsQuery = useApiQuery(
    ['incidents', 'list', { functionalities: id, active: true }],
    () =>
      firehydrantAPI.get('/incidents', {
        params: { functionalities: id, active: true },
      }),
    { enabled: !!functionalityQuery.data?.data?.id },
  );

  const inactiveIncidentsQuery = useApiQuery(
    ['incidents', 'list', { functionalities: id, active: false, per_page: 5 }],
    () =>
      firehydrantAPI.get('/incidents', {
        params: { functionalities: id, active: false, per_page: 5 },
      }),
    { enabled: !!functionalityQuery.data?.data?.id },
  );

  return {
    isLoading:
      functionalityQuery.isLoading ||
      activeIncidentsQuery.isLoading ||
      inactiveIncidentsQuery.isLoading,
    error:
      functionalityQuery.isError ||
      activeIncidentsQuery.isError ||
      inactiveIncidentsQuery.isError,
    functionality: functionalityQuery.data?.data,
    incidents: activeIncidentsQuery.data?.data?.data,
    inactiveIncidents: inactiveIncidentsQuery.data?.data?.data,
  };
};
